/**
 * @fileoverview POST handler for the "/engagement/in_app_message_color_profiles(/:id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementInAppMessageColorProfilesIdCacheKeys } from "./constants";
import type { PostIamTemplateProps, PostIamTemplateResult } from "./types";

export const postEngagementInAppMessageColorProfilesId = reactQueryMutationAdapter(
  engagementInAppMessageColorProfilesIdCacheKeys,
  (props: PostIamTemplateProps): Promise<PostIamTemplateResult> => {
    return fetch(`/engagement/in_app_message_color_profiles/${props.id ?? ""}`, "POST", props);
  }
);
